import { cn } from '@/lib/utils';
import type { IConstructedPromptProps } from '@/@types/photostudio';

export function ConstructedPrompt({ prompt }: IConstructedPromptProps) {
  return (
    <div className="flex flex-col gap-3">
      {/* Badge */}
      <div>
        <span
          className={cn(
            'inline-block rounded-md px-2.5 py-1',
            'bg-primary text-primary-foreground',
            'font-mono text-[10px] font-semibold uppercase tracking-wider'
          )}
        >
          Constructed Prompt
        </span>
      </div>
      {/* Content Box */}
      <div className={cn('h-[100px] rounded-lg border p-4', 'bg-card border-border')}>
        <p className="font-mono text-[12px] leading-relaxed text-foreground-muted">{prompt}</p>
      </div>
    </div>
  );
}
